import React from "react";
import styles from "./styles.module.css";

type Props = {
  text?: React.ReactNode;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Checkbox: React.FC<Props> = ({
  text,
  checked = false,
  disabled = false,
  onChange,
}) => {
  return (
    <label className={disabled ? `${styles.label} ${styles.disabled}` : styles.label}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className={styles.input}
      />
      <span className={styles.checkbox}>
        {checked && (
          <svg
            className={styles.icon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </span>
      {text && <span className={styles.text}>{text}</span>}
    </label>
  );
};